import { LogLevels } from './types/LogLevels';
import * as consoleLogger from './consoleLogger';
import { v4 as uuidv4 } from 'uuid';

let settings = {
    clientId: '',
    sessionId: '',
    url: '/api/Logging'
}

interface ApiLoggerOptions {
    clientId?: string;
    sessionId?: string;
    url?: string;
}

export function configure(options: ApiLoggerOptions) {
    settings = {
        clientId: options.clientId || settings.clientId,
        sessionId:  options.sessionId || settings.sessionId,
        url: options.url || settings.url,
    }
}

export function log(date: Date, level: LogLevels, message: string) {
    let options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-session-id': settings.sessionId,
            'x-correlation-id': uuidv4()
        },
        body: JSON.stringify([
            {
                clientId: settings.clientId,
                timeStamp: date.toISOString(),
                logLevel: level,
                detail: message
            }
        ])
    };

    fetch(settings.url, options)
        .then(response => {
            if (response.status < 200 || response.status >= 400) {
                consoleLogger.log('Warn', 'ApiLogger: Error: Unable to log to apiLogger');
            }
        })
        .catch(() => {
            consoleLogger.log('Warn', 'ApiLogger: Error: Unable to log to apiLogger');
        });
}
